import Joi from "joi";

const CompanySchema = Joi.object({
  code: Joi.string().trim().required().pattern(/^\d+$/).messages({
    "string.empty": "Code is required.",
    "string.pattern.base": "Code must contain only numbers.",
  }),
  name: Joi.string().trim().required().messages({
    "string.empty": "Name is required.",
  }),
  faxNo: Joi.string()
    .pattern(/^\d{6,15}$/) // Allows only numbers (6 to 15 digits)
    .allow("")
    .trim()
    .messages({
      "string.pattern.base": "Fax Number must be 6 to 15 digits number.",
    }),

  contract: Joi.string()
    .pattern(/^\d{10}$/) // Allows only 10-digit numbers
    .allow("")
    .trim()
    .messages({
      "string.pattern.base": "Contact Number must be exactly 10 digits.",
    }),

  email: Joi.string()
    .email({ tlds: { allow: false } }) // Validates proper email format
    .allow("")
    .trim()
    .messages({
      "string.email": "Please enter a valid email address.",
    }),

  pincode: Joi.string()
    .pattern(/^\d{6}$/) // Allows only 6-digit numbers
    .allow("")
    .trim()
    .messages({
      "string.pattern.base": "Pin Code must be exactly 6 digits.",
    }),
  dlno: Joi.string().trim().pattern(/^\d+$/).allow("").messages({
    "string.pattern.base": "DL No must contain only numbers.",
  }),
}).unknown(true);

export default CompanySchema;
